import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

export default function AuditLogs() {
  const [items, setItems] = useState([]);
  const [days, setDays] = useState(30);
  const [entity, setEntity] = useState("");

  const load = async () => {
    const params = new URLSearchParams();
    params.set("days", days);
    if (entity) params.set("entity", entity);
    const { data } = await api.get(`/audit-logs?${params}`);
    setItems(data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [days]);

  return (
    <div className="space-y-6" data-testid="audit-logs-page">
      <div className="flex items-end gap-3">
        <div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-1">Window (days)</div>
          <Input type="number" min="1" max="365" value={days} onChange={(e) => setDays(parseInt(e.target.value) || 30)} className="rounded-none h-9 w-32" data-testid="audit-days" />
        </div>
        <div className="flex-1">
          <div className="text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-1">Entity (filter)</div>
          <Input placeholder="sales_bill | purchase_bill | loyalty | sales_return" value={entity} onChange={(e) => setEntity(e.target.value)} className="rounded-none h-9" data-testid="audit-entity" />
        </div>
        <Button onClick={load} className="bg-slate-900 hover:bg-slate-800 rounded-none h-9" data-testid="audit-refresh">Apply</Button>
      </div>

      <div className="border border-slate-200 bg-white rounded-sm overflow-x-auto">
        <table className="w-full text-sm" data-testid="audit-logs-table">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr>
              <th className="px-4 py-3 text-left font-semibold">Timestamp</th>
              <th className="px-4 py-3 text-left font-semibold">User</th>
              <th className="px-4 py-3 text-left font-semibold">Entity</th>
              <th className="px-4 py-3 text-left font-semibold">Action</th>
              <th className="px-4 py-3 text-left font-semibold">Details</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} className="px-4 py-12 text-center text-slate-500">No audit entries.</td></tr>}
            {items.map((l) => (
              <tr key={l.id} className="border-b border-slate-100 hover:bg-slate-50">
                <td className="px-4 py-3 text-xs font-mono text-slate-600">{(l.timestamp || "").slice(0, 19).replace("T", " ")}</td>
                <td className="px-4 py-3">{l.user_name}</td>
                <td className="px-4 py-3"><Badge variant="outline" className="rounded-none">{l.entity}</Badge></td>
                <td className="px-4 py-3 capitalize">{l.action}</td>
                <td className="px-4 py-3 text-xs text-slate-600 font-mono max-w-2xl truncate">{l.after ? JSON.stringify(l.after) : ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
